import { motion } from "framer-motion";

export const Manifesto = () => (
  <section id="manifesto" className="relative py-28 border-t border-white/10 overflow-hidden">
    <div className="absolute -left-20 top-1/2 -translate-y-1/2 w-[420px] h-[420px] bg-[#00f0ff]/5 blur-[130px] rounded-full pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <p className="font-mono-tech text-xs tracking-[0.35em] text-[#00f0ff] uppercase mb-3">// Manifesto</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase text-white">What R-AN Stands For</h2>
      </div>
      <div className="lg:col-span-8 space-y-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display text-lg sm:text-xl text-slate-200 leading-relaxed"
        >
          R-AN is a new independent record label built for the underground. We sign productions that move floors, not algorithms — and we put every release where listeners actually are.
        </motion.p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {[
            { t: "Global Distribution", d: "Every track lands on Spotify, Apple Music, YouTube, SoundCloud and Beatport on day one." },
            { t: "Artist-First Deals", d: "Transparent splits and full creative control. Your sound stays yours." },
            { t: "Curated Catalogue", d: "A tight roster over a bloated one. Each catalogue number earns its place." },
            { t: "Visibility Engine", d: "Playlist placement, platform pitching and label-side promotion with every release." },
          ].map((f, i) => (
            <motion.div
              key={f.t}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-[#0c0c12] p-6"
            >
              <h3 className="font-mono-tech text-xs tracking-[0.2em] uppercase text-[#ff0055] mb-2">{f.t}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{f.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
